import type { ConnectIntegrationHandler } from "#types/ConnectIntegration.ts";
import { create } from "zustand";

interface ConnectIntegrationStore {
    connectIntegrationHandler?: ConnectIntegrationHandler;
    setConnectIntegrationHandler: (handler?: ConnectIntegrationHandler) => void;
}

export const useConnectIntegrationStore = create<ConnectIntegrationStore>()(set => ({
    connectIntegrationHandler: undefined,
    setConnectIntegrationHandler: connectIntegrationHandler => set({ connectIntegrationHandler })
}));
